import { apiPost, apiDelete } from "./client";

export async function updateGpsLocation(latitude, longitude) {
  return apiPost("/profiles/me/location/gps", { latitude, longitude });
}

export async function clearGpsLocation() {
  return apiDelete("/profiles/me/location/gps");
}
